import React from "react";
import HeroSection from "../../components/home/slideHome";
import GallerySection from "../../components/home/slideHome/GallerySection";

export const HomePage = () => {
  return (
    <div>
      <HeroSection />
    </div>
  );
};
